<template>
  <div class="ma-8 pt-8">
    <products
      exclude-required
      @click:product="
        (product) => {
          $router.push({ name: 'product', params: { id: product.getId() } })
        }
      "
    />
  </div>
</template>

<script>
import Products from '../../products/Products'

export default {
  name: 'ProductsOverview',
  components: { Products },
}
</script>
